import React from 'react'

const BasicdetailsAccount = ({pageJson, data, translations, otherAccount}) => (
  <div className="pooling-structure-container__add-pool">
    <dl className="detail-container__horizontal-row clearfix">
      <dt>{`${translations(pageJson.bDTitle)}`}</dt>
      <dd className="horizontal-rule"> </dd>
      <dt>{translations(pageJson.bDPoolCurrency)}</dt>

    <dd>{'poolCurrency' in data && data.poolCurrency !== undefined && data.poolCurrency.name !== undefined ? data.poolCurrency.name : ''}</dd>
      <dt>&nbsp;</dt>
      <dd>
       {
         data.accountsList.map((item, key) =>
          <dl>
            <dt>{`${translations(pageJson.bDAccount)} ${key+1}`}</dt>
            <dd style={{float:'left'}}>
             <span>{item.accountType !== undefined ? item.accountType.name + ',' : ''}</span>
             <span>{item.accountNumber !== undefined && item.accountNumber !== '' ? item.accountNumber + ',' : ''}</span>
             <span>{item.branchCode !== undefined && item.branchCode !== '' ? item.branchCode + ',' : ''}</span>
             <span>{item.country !== undefined ? item.country.name + ',' : ''}</span>
             <span>{item.currency !== undefined ? item.currency.name : ''}</span>
             <br/>
             <span>{item.accountHolder !== undefined ? item.accountHolder.name : ''}</span>
             <br/>
             <span>{item.hsbcBankName !== undefined ? item.hsbcBankName.name + ',' : ''}</span>
             <span>{item.bankName !== undefined ? item.bankName + ',' : ''}</span>
             <span>{item.accountTitle !== undefined ? item.accountTitle : ''}</span>
             <span>{item.tempRefrenceId !== undefined && item.tempRefrenceId !== '' ? `(${item.tempRefrenceId})` : ''}</span>
            </dd>
          </dl>
        )
      }
      </dd>
  </dl>
  </div>

)

export default BasicdetailsAccount;



// WEBPACK FOOTER //
// ./src/components/CaseList/PreviewGLS/NPPreview/PoolingStructure/basicDetailsAccounts.js